import { IReleaseNote } from "../types"

export const RELEASE_1_4_9: IReleaseNote = {
    status: "PAST",
    title: "v1.4.9",
    date: "8th November 2024",
    releaseType: "Patch",
    notesBodyAllUsers: [
        {
            heading: "Introduction",
            content:
                "Patch 1.4.9 contains changes for the following: a typo fix related to PCC Impedance in the device details webpage for Heat Pumps for Demandd Assesors, and a fix to the '200' Response structure documentation for DNOs & Installers using our APIs",
        },
    ],
    notesBodyInstaller: [
        {
            heading: "For installers using the web portal",
            content: "This release contains no changes to your functionality",
        },
        {
            heading: "For installers using our APIs",
            content: "The following change has been been added:",
            bullets: [
                "An update to the documentation for the Get Installer Applications '200' Response structure. A bug causing 'commissioningInfo' structure to be incorrectly presented has been corrected. This is just a fix to the documentation - no change has been added to the underlying API",
            ],
        },
    ],
    notesBodyDno: [
        {
            heading: "For DNOs using the web portal",
            content: "This release contains no changes to your functionality",
        },
        {
            heading: "For DNOs using our APIs",
            content: "The following change has been been added:",
            bullets: [
                "An update to the documentation for the Get DNO Applications '200' Response structure. A bug causing 'commissioningInfo' structure to be incorrectly presented has been corrected. This is just a fix to the documentation - no change has been added to the underlying API",
            ],
        },
    ],
    notesBodyManu: [
        {
            heading: "For manufacturers using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorDemand: [
        {
            heading: "For demand evaluators using the web portal",
            content: "The following change has been been added:",
            bullets: [
                "A minor typo fix to correct the line 'Impedance at PCC' within the Heat Pump 'Device Details'",
            ],
        },
    ],
    notesBodyDbAssessorGen: [
        {
            heading: "For generation evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
}
